var map = {
	"./google-play-badge-da-DK.svg": 83122,
	"./google-play-badge-de-DE.svg": 24240,
	"./google-play-badge-en-GB.svg": 65010,
	"./google-play-badge-en-US.svg": 37369,
	"./google-play-badge-es-ES.svg": 7306,
	"./google-play-badge-es-MX.svg": 28329,
	"./google-play-badge-fr-FR.svg": 99242,
	"./google-play-badge-it-IT.svg": 23176,
	"./google-play-badge-nb-NO.svg": 63175,
	"./google-play-badge-nl-NL.svg": 28838,
	"./google-play-badge-pl-PL.svg": 78686,
	"./google-play-badge-pt-BR.svg": 65122,
	"./google-play-badge-pt-PT.svg": 75454,
	"./google-play-badge-sv-SE.svg": 81115
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 31724;